export default "/images/en.png?956c4b0e2ec1c480d890002aa998ec5c";